export const routePaths = {
  home: "/home",
  about: "/about",
  softwareTesting: "/software-testing",
  manualTesting: "/manual-testing",
  automationTesting: "/automation-testing",
  automationTestcases: "/automation-testcase",
  automationTestingTopic: "/automation-testing-topic",
  apiTesting: "/api-testing",
  apiCheatSheet: "/API-testing-cheatSheet",
  studyNotes: "/study-notes",
  premiumNotes: "/premium-pdfs",
  jiraNotes: "/jira-notes",
  jiraNotesCheckout: "/jira-notes/checkout",
  jiraNotesDownload: "/jira-notes/download",
  interviewQuestions: "/testing-interview-questions",
  apiInterview: "/api-testing-interview",
  enroll: "/enroll",
  contact: "/contact",
  testingBlog: "/testing-blog",
  blogArchive: "/testing-types-blog",
  testingTypes: "/testing-types",
  testingMethods: "/testing-methods",
  testingTools: "/testing-tools",
  sdlc: "/what-is-sdlc",
  performanceTesting: "/what-is-performance-testing",
  testPlanTemplate: "/test-plan-template",
  testEnvironment: "/test-environment-page",
  login: "/login",
  signup: "/signup-page",
  onboarding: "/onboarding",
  unauthorized: "/unauthorized",
  admin: "/admin",
  trainer: "/trainer",
  leadCrm: "/lead-crm",
  bugs: "/bugs",
  bugsCreate: "/bugs/create",
  myBugs: "/my-bugs",
  assignedBugs: "/assigned-bugs",
  bugDetail: (id = ":id") => `/bugs/${id}`,
  student: "/student",
  privacyPolicy: "/privacy-policy",
  terms: "/terms",
  refundPolicy: "/refund-policy",
  product: "/product",
  flashSales: "/flash-sales",
  productsByCategory: "/product_phone_tablets",
  productSearch: "/product-search",
  productDetails: (id = ":id") => `/product-details/${id}`,
  cart: "/add-to-cart",
  address: "/address",
  payment: "/payment",
  orderHistory: "/orders-history",
  orderSuccess: "/orders-success",
  invoice: (invoiceNumber = ":invoiceNumber") => `/invoice/${invoiceNumber}`,
  orderTracking: (invoiceNumber = ":invoiceNumber") => `/track-order/${invoiceNumber}`,
};

export const publicRoutes = [
  routePaths.home,
  routePaths.softwareTesting,
  routePaths.manualTesting,
  routePaths.automationTesting,
  routePaths.apiTesting,
  routePaths.enroll,
  routePaths.contact,
  routePaths.jiraNotes,
  routePaths.jiraNotesCheckout,
  routePaths.jiraNotesDownload,
  routePaths.login,
  routePaths.signup,
  routePaths.unauthorized,
  routePaths.privacyPolicy,
  routePaths.terms,
  routePaths.refundPolicy,
];

export const protectedRoutes = [
  routePaths.admin,
  routePaths.trainer,
  routePaths.leadCrm,
  routePaths.bugs,
  routePaths.bugsCreate,
  routePaths.myBugs,
  routePaths.assignedBugs,
  routePaths.student,
  routePaths.onboarding,
];
